import React, { useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import CountUp from 'react-countup';

import { FormContext } from 'contexts/FormContext';
import { LmsContext } from 'contexts/LmsContext';

import { Button, Loader } from 'components/common';
import {
  StepContainer
} from 'components/CASAForm';
import {
  AuCallout, AuDirectionLink
} from 'components/DTA';

import { DroneAccreditationFormData } from 'types/forms/droneAccreditationTypes';

interface IAssessmentResult {
  resetQuestionIndex: () => void;
}

const AssessmentResult: React.FC<IAssessmentResult> = ({ resetQuestionIndex }) => {
  const { resetForm } = useFormikContext<DroneAccreditationFormData>();
  const { openStepById } = useContext(FormContext);
  const { dashboardUrl, percentCorrect, passed, submissionInProgress } = useContext(LmsContext);

  useEffect(() => {
    resetForm();
  }, []);

  const onRetry = () => {
    // Reset the question index otherwise all previous answers get added into Formik as the index doesnt update intime
    resetQuestionIndex();

    // Navigate back to intro video
    openStepById('IntroVideo');
  };

  if (submissionInProgress) {
    return <Loader message='Working. Please wait.....' />;
  }

  return (
    <StepContainer hidePreviousLink>
      <div>
        <div style={{
          borderRadius: '50%',
          height: '300px',
          width: '300px',
          margin: 'auto',
          border: '8px solid #ccc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <CountUp
            end={percentCorrect}
            duration={3}
            suffix='%'
            useEasing
            style={{ fontSize: '3em', fontWeight: 700 }}
          />
        </div>
      </div>

      {
        passed ?
          <AuCallout>
            <p>
              <b>Congratulations!</b><br />
              You have successfully achieved accreditation!<br />
              To download your results, visit the drone accreditation section of your myCASA account.
            </p>
          </AuCallout>
          : <AuCallout>
            <p>
              Thank you for your attempt to achieve accreditation.<br />
              Unfortunately, on this occasion, you have been unsuccessful.<br />
              Please try again!
            </p>
          </AuCallout>
      }

      {
        !passed &&
        <Button as='primary' onClick={onRetry}>Try again</Button>
      }

      <AuDirectionLink
        text='Return to myCASA'
        link={dashboardUrl}
        direction='left'
        style={{ display: 'block', marginTop: '25px' }}
      />
    </StepContainer>
  );
};

export default AssessmentResult;
